/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetOrganizationChatSettingResponseData,
  GetOrganizationChatSettingResponseDataFromJSON,
  GetOrganizationChatSettingResponseDataFromJSONTyped,
  GetOrganizationChatSettingResponseDataToJSON
} from './GetOrganizationChatSettingResponseData'

/**
 *
 * @export
 * @interface GetOrganizationChatSettingResponse
 */
export interface GetOrganizationChatSettingResponse {
  /**
   *
   * @type {number}
   * @memberof GetOrganizationChatSettingResponse
   */
  status?: number
  /**
   *
   * @type {GetOrganizationChatSettingResponseData}
   * @memberof GetOrganizationChatSettingResponse
   */
  data?: GetOrganizationChatSettingResponseData
}

export function GetOrganizationChatSettingResponseFromJSON(json: any): GetOrganizationChatSettingResponse {
  return GetOrganizationChatSettingResponseFromJSONTyped(json, false)
}

export function GetOrganizationChatSettingResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetOrganizationChatSettingResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetOrganizationChatSettingResponseDataFromJSON(json['data'])
  }
}

export function GetOrganizationChatSettingResponseToJSON(value?: GetOrganizationChatSettingResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetOrganizationChatSettingResponseDataToJSON(value.data)
  }
}
